import { Reply, Send } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import toList from './ComponentUtil';
import CustomButton from './CustomButton';
import CustomTextField from './CustomTextField';
import ProfilePic from '../../images/Ellipse_170.png';


function Comments({ data = [] }) {
    const [comments, setComments] = useState(data);
    const [getReply, setGetReply] = useState([]);
    const [showReplies, setShowReplies] = useState([]);

    useEffect(() => {
        setComments(data);
    }, [data]);

    const [inputText, setInputText] = useState('');
    const handleInputChange = (e) => {
        setInputText(e.target.value);
    }

    function toggleReply(e, i) {
        getReply[i] = !getReply[i];
        setGetReply([...getReply]);
    }

    function toggleReplies(e, i) {
        showReplies[i] = !showReplies[i];
        setShowReplies([...showReplies]);
    }

    function onSubmit(e, item, i) {
        item.replies = item.replies || [];
        item.replies.push({
            comment: inputText,
            user: {
                img: ProfilePic,
                name: 'Kaira'
            },
            date: new Date().toISOString().slice(0, 10),
            replies: []
        });
        toggleReply(e, i);
        setComments([...comments]);
        setInputText('');
    }


    return (
        <div className='comments-wrp'>
            {toList(comments, undefined, (item, i) =>
                <div key={i} className='comment-wrp'>
                    <div className='profile-wrp'>
                        <img src={item?.user?.img} alt='profile-pic' />
                        <p>{item?.user?.name}</p>
                    </div>
                    <div>{item?.comment}</div>
                    <div className='comment-reply-wrp'>
                        {item?.replies && item?.replies?.length > 0 && <CustomButton name={item?.replies?.length + ' Comments'} onClick={e => toggleReplies(e,i)} icon={<Send />}></CustomButton>}
                        <CustomButton onClick={(e) => toggleReply(e, i)} name={'Reply'} icon={<Reply />}></CustomButton>
                        {getReply[i] && <div className='reply-input-wrp'>
                            <CustomTextField value={inputText} onChange={handleInputChange} variant='standard' />
                            <CustomButton onClick={(e) => onSubmit(e, item, i)} name='Send' icon={<Send />}></CustomButton>
                        </div>}
                    </div>
                    <div className='replies-wrp'>
                        {item?.replies && showReplies[i] && item?.replies?.length > 0 && <Comments data={item?.replies} />}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Comments;